/**
 * Inline SVG logo mark + text.
 * Diamond with upward-chart arrow — visible on both light and dark backgrounds.
 * `onLight` prop makes the inner arrow dark (for light backgrounds).
 */
export default function BrandLogo({
  size = 36,
  showText = false,
  brand = "Expansión Rubí",
  sub = "Proyecto Diamante",
  className = "",
  onLight = false,
}) {
  const barColor = onLight ? "#17140F" : "#F5EFE4";
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        className={onLight ? "drop-shadow-[0_2px_8px_rgba(255,191,87,0.35)]" : "drop-shadow-[0_0_16px_rgba(255,191,87,0.4)]"}
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="champagneGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#FFCF7F" />
            <stop offset="55%" stopColor="#FFBF57" />
            <stop offset="100%" stopColor="#FFBF57" />
          </linearGradient>
        </defs>
        <path
          d="M50 6 L94 42 L50 94 L6 42 Z"
          fill="none"
          stroke="url(#champagneGrad)"
          strokeWidth="9"
          strokeLinejoin="round"
        />
        <g transform="translate(30, 62)">
          <rect x="0" y="-2" width="8" height="18" fill={barColor} rx="1" />
          <rect x="12" y="-10" width="8" height="26" fill={barColor} rx="1" />
          <rect x="24" y="-20" width="8" height="36" fill="url(#champagneGrad)" rx="1" />
          <path d="M32 -22 L40 -14 L32 -14 Z" fill="url(#champagneGrad)" />
        </g>
      </svg>
      {showText && (
        <div className="flex flex-col leading-tight">
          <span className={`font-display text-sm tracking-tight ${onLight ? "text-[#17140F]" : "text-[#F5EFE4]"}`}>{brand}</span>
          <span className={`font-mono text-[9px] uppercase tracking-[0.22em] ${onLight ? "text-[#52525B]" : "text-[#FFBF57]"}`}>{String(sub || "").replace(/elixir/gi, "Diamante")}</span>
        </div>
      )}
    </div>
  );
}
